module.exports = __webpack_public_path__ + "static/media/bottlings11.e8d7fbbe.jpg";